module.exports = __webpack_public_path__ + "static/media/ProximaNova-RegularItalic.1b29fabe.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-RegularItalic.ttf
// module id = 3526
// module chunks = 68